// // PartnerFormStep5.tsx
// import React, { useEffect, useMemo } from "react";
// import { usePartnerFormStore } from "../store/usePartnerFormStore";
// import { NavigationButtons } from "./ui";
// import {
//   calculatePayment,
//   getPaymentBreakdown,
// } from "../utils/calculatePayment";

// const PartnerFormStep5: React.FC = () => {
//   const {
//     listingDetails,
//     updateListingDetails,
//     serviceDetails,
//     coverageAreas,
//     previousStep,
//     nextStep,
//     setError,
//   } = usePartnerFormStore();

//   const currentService = serviceDetails.services;

//   // Calculate payment amount using plan-based pricing
//   const paymentBreakdown = useMemo(() => {
//     if (!coverageAreas.selectedPlan) return null;
//     return getPaymentBreakdown({
//       selectedPlan: coverageAreas.selectedPlan,
//       selectedHexagons: coverageAreas.selectedHexagons,
//     });
//   }, [coverageAreas]);

//   const calculatedAmount = useMemo(() => {
//     return calculatePayment({
//       selectedPlan: coverageAreas.selectedPlan,
//       selectedHexagons: coverageAreas.selectedHexagons,
//     });
//   }, [coverageAreas]);

//   // Format selected services for display
//   const selectedServicesText = useMemo(() => {
//     if (!currentService.category) return "";
//     return `${currentService.category}: ${currentService.subcategories.join(", ")}`;
//   }, [currentService]);

//   useEffect(() => {
//     // Update listing details with summary and calculated amount
//     updateListingDetails({
//       selectedCategory: selectedServicesText,
//       selectedAreas: coverageAreas.selectedPlan
//         ? [`${coverageAreas.selectedPlan.planName} Plan (${coverageAreas.selectedHexagons.length} hexagons)`]
//         : [],
//       listingAmount: calculatedAmount,
//       totalServiceCharge: calculatedAmount,
//     });
//   }, [
//     calculatedAmount,
//     selectedServicesText,
//     coverageAreas,
//     updateListingDetails,
//   ]);

//   const validateStep = (): boolean => {
//     if (calculatedAmount <= 0) {
//       setError(
//         "listingAmount",
//         "Please complete previous steps to calculate payment amount"
//       );
//       return false;
//     }
//     return true;
//   };

//   const handleNext = () => {
//     if (validateStep()) {
//       nextStep();
//     }
//   };

//   return (
//     <div className="space-y-5 md:space-y-6">
//       <div>
//         <h2 className="text-xl md:text-2xl font-semibold text-secondary-900 mb-2">
//           Listing Details
//         </h2>
//         <p className="text-sm md:text-base text-secondary-600">
//           Review your coverage plan and payment summary
//         </p>
//       </div>

//       <div className="space-y-5 md:space-y-4">
//         {/* Payment Breakdown */}
//         {paymentBreakdown && (
//           <div className="p-4 md:p-5 bg-gradient-to-br from-primary-50 to-secondary-50 rounded-lg space-y-4 border-2 border-primary-200">
//             <h3 className="font-semibold text-base md:text-lg text-secondary-900">
//               Coverage Plan Breakdown:
//             </h3>

//             <div className="space-y-3">
//               <div className="flex justify-between items-center">
//                 <span className="text-sm text-secondary-700">
//                   Plan:
//                 </span>
//                 <span className="text-sm font-medium text-secondary-900">
//                   {paymentBreakdown.planName}
//                 </span>
//               </div>

//               <div className="flex justify-between items-center">
//                 <span className="text-sm text-secondary-700">
//                   Hexagons Selected:
//                 </span>
//                 <span className="text-sm font-medium text-secondary-900">
//                   {paymentBreakdown.selectedCount} / {paymentBreakdown.hexLimit}
//                 </span>
//               </div>

//               <div className="flex justify-between items-center">
//                 <span className="text-sm text-secondary-700">
//                   Coverage Area:
//                 </span>
//                 <span className="text-sm font-medium text-secondary-900">
//                   ~{paymentBreakdown.coverageAreaKm2.toFixed(1)} km²
//                 </span>
//               </div>

//               <div className="pt-3 border-t border-primary-200">
//                 <div className="flex justify-between items-center">
//                   <span className="text-base font-semibold text-secondary-900">
//                     Annual Payment:
//                   </span>
//                   <span className="text-2xl md:text-3xl font-bold text-primary-600">
//                     ₹{paymentBreakdown.totalAmount.toLocaleString()}
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Summary */}
//         <div className="p-4 md:p-5 bg-secondary-50 rounded-lg space-y-4 border border-secondary-200">
//           <h3 className="font-semibold text-base md:text-lg text-secondary-900">
//             Summary of Selections:
//           </h3>

//           <div className="space-y-3">
//             <div>
//               <p className="text-sm font-medium text-secondary-700 mb-1">
//                 Selected Services:
//               </p>
//               <p className="text-sm md:text-base text-secondary-600 break-words">
//                 {selectedServicesText || "None selected"}
//               </p>
//             </div>

//             <div>
//               <p className="text-sm font-medium text-secondary-700 mb-1">
//                 Service Count:
//               </p>
//               <p className="text-sm md:text-base text-secondary-600">
//                 1 category, {currentService.subcategories.length} subcategories
//               </p>
//             </div>

//             <div>
//               <p className="text-sm font-medium text-secondary-700 mb-1">
//                 Coverage Plan:
//               </p>
//               <p className="text-sm md:text-base text-secondary-600 break-words">
//                 {listingDetails.selectedAreas?.join(", ") || "None selected"}
//               </p>
//             </div>

//             {paymentBreakdown && (
//               <>
//                 <div>
//                   <p className="text-sm font-medium text-secondary-700 mb-1">
//                     Hexagons Selected:
//                   </p>
//                   <p className="text-sm md:text-base text-secondary-600">
//                     {paymentBreakdown.selectedCount} (~{paymentBreakdown.coverageAreaKm2.toFixed(1)} km²)
//                   </p>
//                 </div>
//               </>
//             )}
//           </div>
//         </div>
//       </div>

//       <NavigationButtons
//         onPrevious={previousStep}
//         onNext={handleNext}
//         nextLabel="Next: Payment & Completion"
//       />
//     </div>
//   );
// };

// export default PartnerFormStep5;



import React, { useEffect, useMemo } from "react";
import { usePartnerFormStore } from "../store/usePartnerFormStore";
import { NavigationButtons } from "./ui";
import { getPaymentBreakdown } from "../utils/calculatePayment";
import { Plan, formatBranchAddress } from "../store/types";

const PartnerFormStep5: React.FC = () => {
  const {
    listingDetails,
    updateListingDetails,
    serviceDetails,
    coverageAreas,
    branchDetails,
    additionalInfo,
    previousStep,
    nextStep,
    setError,
  } = usePartnerFormStore();

  const currentService = serviceDetails.services;
  const selectedPlan = coverageAreas.selectedPlan;
  const isTrial = selectedPlan?.isTrial === "yes";

  // Calculate payment amount using plan-based pricing
  const paymentBreakdown = useMemo(() => {
    if (!selectedPlan) return null;
    return getPaymentBreakdown({
      selectedPlan: selectedPlan as Plan,
      selectedHexagons: coverageAreas.selectedHexagons,
    });
  }, [selectedPlan, coverageAreas.selectedHexagons]);

  const calculatedAmount = paymentBreakdown?.totalAmount || 0;

  // Format selected services for display
  const selectedServicesText = useMemo(() => {
    if (!currentService.category) return "";
    return `${currentService.category}: ${currentService.subcategories.join(", ")}`;
  }, [currentService]);

  // Format branch address
  const branchAddress = useMemo(() => {
    return formatBranchAddress(branchDetails);
  }, [branchDetails]);

  // Get operating hours summary
  const operatingHoursSummary = useMemo(() => {
    if (!branchDetails?.operatingHours || branchDetails.operatingHours.length === 0) {
      return "Not specified";
    }
    const openDays = branchDetails.operatingHours.filter(h => h.isOpen).map(h => h.day);
    if (openDays.length === 0) return "Closed all days";
    if (openDays.length === 7) return "Open all days";
    return `Open on ${openDays.length} days`;
  }, [branchDetails]);

  useEffect(() => {
    // Update listing details with summary and calculated amount
    const planDisplayName = selectedPlan?.displayName || selectedPlan?.name || "No Plan";
    updateListingDetails({
      selectedCategory: selectedServicesText,
      selectedAreas: [
        `${planDisplayName} Plan`,
        branchDetails?.branchName ? `Branch: ${branchDetails.branchName}` : "",
        branchAddress ? `Location: ${branchAddress}` : "",
      ].filter(Boolean),
      listingAmount: calculatedAmount,
      totalServiceCharge: calculatedAmount,
    });
  }, [calculatedAmount, selectedServicesText, selectedPlan, branchDetails, branchAddress, updateListingDetails]);

  const validateStep = (): boolean => {
    if (calculatedAmount <= 0 && !isTrial) {
      setError(
        "listingAmount",
        "Please complete previous steps to calculate payment amount"
      );
      return false;
    }
    return true;
  };

  const handleNext = () => {
    if (validateStep()) {
      nextStep();
    }
  };

  return (
    <div className="space-y-5 md:space-y-6">
      <div>
        <h2 className="text-xl md:text-2xl font-semibold text-secondary-900 mb-2">
          Review Your Application
        </h2>
        <p className="text-sm md:text-base text-secondary-600">
          Review all your details before proceeding to payment
        </p>
      </div>

      <div className="space-y-5 md:space-y-4">
        {/* Payment Breakdown */}
        {paymentBreakdown && (
          <div className={`p-4 md:p-5 bg-gradient-to-br rounded-lg space-y-4 border-2 ${
            isTrial 
              ? "from-amber-50 to-amber-100 border-amber-300" 
              : "from-primary-50 to-secondary-50 border-primary-200"
          }`}>
            <h3 className="font-semibold text-base md:text-lg text-secondary-900">
              Coverage Plan Breakdown:
            </h3>

            {(isTrial || paymentBreakdown.payAfterSales > 0) && (
              <div className="bg-amber-100 border border-amber-300 rounded-lg p-3 space-y-1">
                {isTrial && selectedPlan?.trialDays > 0 && (
                  <p className="text-sm font-medium text-amber-800">
                    Trial Plan - {selectedPlan.trialDays} days trial period
                  </p>
                )}
                {paymentBreakdown.payAfterSales > 0 && (
                  <p className="text-sm font-medium text-amber-800">
                    Pay ₹{paymentBreakdown.payAfterSales.toLocaleString()} (ex. GST) After First Sale
                  </p>
                )}
              </div>
            )}

            <div className="space-y-3">
              <div className="flex justify-between items-center">
                <span className="text-sm text-secondary-700">Plan:</span>
                <span className="text-sm font-medium text-secondary-900">
                  {paymentBreakdown.planName}
                  {selectedPlan?.type === 'custom' ? " (Custom Plan)" : ""}
                  {isTrial && " (Trial)"}
                </span>
              </div>

              <div className="flex justify-between items-center">
                <span className="text-sm text-secondary-700">Coverage Hexagons:</span>
                <span className="text-sm font-medium text-secondary-900">
                  {selectedPlan?.type === 'custom' || selectedPlan?.name?.toLowerCase().includes('custom')
                    ? `${paymentBreakdown.selectedCount} hexagons (Custom Selection)`
                    : selectedPlan?.features?.hexCount === 0
                    ? "Full Kerala (Statewide)"
                    : `${paymentBreakdown.selectedCount} / ${paymentBreakdown.hexLimit}`}
                </span>
              </div>

              {(selectedPlan?.type === 'custom' || selectedPlan?.name?.toLowerCase().includes('custom')) && (
                <div className="flex justify-between items-center text-secondary-600">
                  <span className="text-sm">Rate per Hexagon:</span>
                  <span className="text-sm font-medium text-secondary-900">
                    ₹{(selectedPlan.costPerHex || selectedPlan.pricing?.costPerHex || 0).toLocaleString()} / hex
                  </span>
                </div>
              )}

              <div className="flex justify-between items-center">
                <span className="text-sm text-secondary-700">Coverage Area:</span>
                <span className="text-sm font-medium text-secondary-900">
                  ~{paymentBreakdown.coverageAreaKm2.toFixed(1)} km²
                </span>
              </div>

              <div className="flex justify-between items-center">
                <span className="text-sm text-secondary-700">Base Amount:</span>
                <span className="text-sm font-medium text-secondary-900">
                  ₹{paymentBreakdown.pricePerYear.toLocaleString()}
                </span>
              </div>

              <div className="pl-4 space-y-1">
                <div className="flex justify-between items-center text-secondary-600">
                  <span className="text-sm">CGST (9%):</span>
                  <span className="text-sm">+₹{Math.round((paymentBreakdown.pricePerYear * 0.09)).toLocaleString()}</span>
                </div>
                <div className="flex justify-between items-center text-secondary-600">
                  <span className="text-sm">SGST (9%):</span>
                  <span className="text-sm">+₹{Math.round((paymentBreakdown.pricePerYear * 0.09)).toLocaleString()}</span>
                </div>
              </div>

              {paymentBreakdown.discount > 0 && (
                <div className="flex justify-between items-center text-green-600">
                  <span className="text-sm">Discount Applied:</span>
                  <span className="text-sm font-medium">-₹{paymentBreakdown.discount.toLocaleString()}</span>
                </div>
              )}

              <div className="pt-3 border-t border-primary-200">
                <div className="flex justify-between items-center">
                  <span className="text-base font-semibold text-secondary-900">
                    {isTrial ? "Trial Amount:" : "Annual Payment:"}
                  </span>
                  <span className="text-2xl md:text-3xl font-bold text-primary-600">
                    ₹{paymentBreakdown.totalAmount.toLocaleString()}
                  </span>
                </div>
                <p className="text-xs text-secondary-500 mt-1 text-right">
                  (Inclusive of CGST & SGST)
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Selected Services */}
        <div className="p-4 md:p-5 bg-white rounded-lg space-y-4 border border-secondary-200">
          <h3 className="font-semibold text-base md:text-lg text-secondary-900">
            Selected Services
          </h3>
          <div className="space-y-3">
            <div>
              <p className="text-sm font-medium text-secondary-700 mb-1">
                Category & Subcategories:
              </p>
              <p className="text-sm md:text-base text-secondary-600 break-words">
                {selectedServicesText || "None selected"}
              </p>
            </div>
            <div>
              <p className="text-sm font-medium text-secondary-700 mb-1">
                Service Charge Category:
              </p>
              <p className="text-sm md:text-base text-secondary-600 capitalize">
                {currentService.serviceChargeCategory || "Not specified"}
              </p>
            </div>
          </div>
        </div>

        {/* Branch Details */}
        {branchDetails && (
          <div className="p-4 md:p-5 bg-white rounded-lg space-y-4 border border-secondary-200">
            <h3 className="font-semibold text-base md:text-lg text-secondary-900">
              Primary Branch Details
            </h3>
            <div className="space-y-3">
              <div>
                <p className="text-sm font-medium text-secondary-700 mb-1">
                  Branch Name:
                </p>
                <p className="text-sm md:text-base text-secondary-600">
                  {branchDetails.branchName}
                </p>
              </div>
              <div>
                <p className="text-sm font-medium text-secondary-700 mb-1">
                  Branch Type:
                </p>
                <p className="text-sm md:text-base text-secondary-600 capitalize">
                  {branchDetails.branchType?.replace('_', ' ') || "Not specified"}
                </p>
              </div>
              {branchDetails.contactPerson?.name && (
                <div>
                  <p className="text-sm font-medium text-secondary-700 mb-1">
                    Contact Person:
                  </p>
                  <p className="text-sm md:text-base text-secondary-600">
                    {branchDetails.contactPerson.name}
                    {branchDetails.contactPerson.phone && ` (${branchDetails.contactPerson.phone})`}
                  </p>
                </div>
              )}
              <div>
                <p className="text-sm font-medium text-secondary-700 mb-1">
                  Location:
                </p>
                <p className="text-sm md:text-base text-secondary-600">
                  {branchAddress || "Location selected on map"}
                </p>
                {branchDetails.location?.coordinates && (
                  <p className="text-xs text-secondary-500 mt-1">
                    Coordinates: {branchDetails.location.coordinates[1].toFixed(6)}, {branchDetails.location.coordinates[0].toFixed(6)}
                  </p>
                )}
              </div>
              <div>
                <p className="text-sm font-medium text-secondary-700 mb-1">
                  Operating Hours:
                </p>
                <p className="text-sm md:text-base text-secondary-600">
                  {operatingHoursSummary}
                </p>
              </div>
              {branchDetails.nearbyHexagons && branchDetails.nearbyHexagons.length > 0 && (
                <div>
                  <p className="text-sm font-medium text-secondary-700 mb-1">
                    Coverage Hexagons:
                  </p>
                  <p className="text-sm md:text-base text-secondary-600">
                    {branchDetails.nearbyHexagons.length} hexagons around your branch
                  </p>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Additional Information */}
        <div className="p-4 md:p-5 bg-white rounded-lg space-y-4 border border-secondary-200">
          <h3 className="font-semibold text-base md:text-lg text-secondary-900">
            Additional Information
          </h3>
          <div className="space-y-3">
            <div>
              <p className="text-sm font-medium text-secondary-700 mb-1">
                Income Sharing Percentage:
              </p>
              <p className="text-sm md:text-base text-secondary-600">
                {additionalInfo.incomeSharingPercentage}% of total income
              </p>
            </div>
            {additionalInfo.additionalWorkQuantity && (
              <div>
                <p className="text-sm font-medium text-secondary-700 mb-1">
                  Additional Work Quantity:
                </p>
                <p className="text-sm md:text-base text-secondary-600">
                  {additionalInfo.additionalWorkQuantity} units
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Summary Card */}
        <div className="p-4 md:p-5 bg-primary-50 rounded-lg border border-primary-200">
          <h3 className="font-semibold text-base md:text-lg text-secondary-900 mb-3">
            Application Summary
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
            <div>
              <span className="text-secondary-600">Business:</span>
              <span className="ml-2 font-medium text-secondary-900">{listingDetails.selectedCategory?.split(':')[0]}</span>
            </div>
            <div>
              <span className="text-secondary-600">Subcategories:</span>
              <span className="ml-2 font-medium text-secondary-900">{currentService.subcategories.length}</span>
            </div>
            <div>
              <span className="text-secondary-600">Coverage:</span>
              <span className="ml-2 font-medium text-secondary-900">{paymentBreakdown?.selectedCount || 0} hexagons</span>
            </div>
            <div>
              <span className="text-secondary-600">Branch:</span>
              <span className="ml-2 font-medium text-secondary-900">{branchDetails?.branchName || 'Not specified'}</span>
            </div>
            <div>
              <span className="text-secondary-600">Income Share:</span>
              <span className="ml-2 font-medium text-secondary-900">{additionalInfo.incomeSharingPercentage}%</span>
            </div>
            <div>
              <span className="text-secondary-600">Total Payment:</span>
              <span className="ml-2 font-bold text-primary-600">
                ₹{calculatedAmount.toLocaleString()}
              </span>
            </div>
          </div>
        </div>
      </div>

      <NavigationButtons
        onPrevious={previousStep}
        onNext={handleNext}
        nextLabel={isTrial ? "Next: Complete Registration" : "Next: Payment"}
      />
    </div>
  );
};

export default PartnerFormStep5;